import { useTranslation } from 'react-i18next';

const SelectOneOption = () => {
  const { t } = useTranslation();
  return <h4 className='font-medium'>{t('Select one option')}:</h4>;
};

export default SelectOneOption;
